export function scrollToSection(section) {
    var collapseHeight = $(section + " .collapse").height();
    var screenHeight =$(window).height(); // screen height

    var heightNoCollapse = 0;
    $('.collapse').each(function() {
        heightNoCollapse += $(this).height +150;
    });

    if(collapseHeight === undefined) {
        collapseHeight = 0;   
    }

    var scroll = $(section).offset().top - collapseHeight;
    var sectionNum = $(section).attr('data-section');
    var i;
    var height = 0;
    var screenMovile = 0;
    for(i = 1; i<=sectionNum; i++) {
        var sec = $('div[data-section='+(i-1)+"]");
        if(i>1) {
            height += $(sec).height();
            if(screen.width<400) {
                screenMovile = 200;
            } 
        }
    }

    if(screen.width<600) {
        if(section === '#appointment_advisor') {
            $('html, body').animate({
                scrollTop:  0
            }, 100, 'swing');
        } else if(section === '#appointment_datos') {
            $('html, body').animate({
                scrollTop:  150
            }, 100, 'swing');
        } else {
            $('html, body').animate({
                scrollTop:  $(section).offset().top - 200
            }, 100, 'swing');
        }
    } else {
        $('html, body').animate({
            scrollTop:  $(section).offset().top - 300
        }, 1000, 'swing'); 
    }
}

export function onLoadWindows() {
    var screenHeight =$(window).height(); // screen height
    if($('.page-body').length>0 && screenHeight>1000) {
        window.onload = function() {
            $('html, body').animate({
                scrollTop: $('.page-body').offset().top
            }, 10);
        }
    }
}

export function scrollSummary(section) {
    $(section).find('.collapse').addClass('show');
    $('html, body').animate({
        scrollTop: $(section).offset().top
    }, 1000, 'swing');
}

export function scrollToError(errorBlock) {
    console.log($(errorBlock).offset().top);
    $('html, body').animate({
        scrollTop: $(errorBlock).offset().top
    }, 1000, 'swing');
}